import React from 'react'
import axios from 'axios'
import i18n from './locales/i18n'

const preflight = () => {
    let userLang = window.location.pathname.substring(0, 4).replace('/', '').replace('/', '')

    window.moment.locale(userLang === 'en' ? 'en-gb' : userLang)

    window.axios = axios

    window.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Accept-Language': userLang,
    }

    window.axios.interceptors.response.use(null, err => {
        if (err?.response?.status === 429) {
            return window.swalert(i18n.t('serverError.429'))
        }

        if (err?.response?.status === 500) {
            window.swalert(i18n.t('serverError.500'))
        }

        return Promise.reject(err.response)
    })
}

export default preflight
